import React from "react";
import { GeneralMessage, useGeneralMessage } from "../../../common/APICommon";
import UploadingScheduleModule from "../../components/modules/UploadingSchedule/UploadingScheduleModule";

const UploadingSchedulePage = ({ user, isHideSideMenu }) => {
  const { showMessage, message, isSuccess, showGeneralMessage } = useGeneralMessage();

  return (
    <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
      <div className="LeftSpace" />
      <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
        <div className="MainteInfo shadow-xl bg-white rounded-lg overflow-hidden">
          <UploadingScheduleModule
            user={user}
            showGeneralMessage={showGeneralMessage}
          />
        </div>
      </div>
      <GeneralMessage form={showMessage} message={message} isSuccess={isSuccess} />
    </div>
  );
};

export default UploadingSchedulePage;